import * as c from '@chakra-ui/react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { UserAvatarIcon } from 'src/components/navbar/icons/user-avatar.icon'
import { useAuth } from 'src/pages/auth/auth-context'

import HelpSection from '../help'
import MenuHeader from './content/header'
import MyProfile from './content/my-profile'

const MenuProfile = () => {
  const { t } = useTranslation('components/nav')

  const { isAuth } = useAuth()
  const { onToggle, onOpen, onClose, isOpen } = c.useDisclosure()
  const { pathname } = useLocation()

  useEffect(() => {
    onClose()
  }, [pathname])

  return (
    <c.Menu
      variant="navbar"
      placement="bottom-end"
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onToggle}
    >
      <c.MenuButton
        as={c.Button}
        maxHeight="30px"
        py="s1"
        px="s2"
        bg="primary.500"
        _hover={{ bg: 'primary.600' }}
        _active={{
          bg: 'primary.600',
          shadow: 'none',
        }}
        transition="none"
        leftIcon={
          <c.Icon as={UserAvatarIcon} w="1rem" h="1rem" color="black.0" />
        }
      >
        <c.Text fontSize="t-sm.1" fontWeight="bold" color="black.0">
          {isAuth
            ? t('components/nav:MENU_LOGGED')
            : t('components/nav:MENU_NOTLOGGED')}
        </c.Text>
      </c.MenuButton>

      <c.MenuList py="s6" px="s5" width="350px" maxH="calc(100vh - 100px)">
        <c.Flex direction="column" gap="s6">
          <MenuHeader isLogged={isAuth} />
          <MyProfile isLogged={isAuth} />
          <HelpSection />
        </c.Flex>
      </c.MenuList>
    </c.Menu>
  )
}

export default MenuProfile
